import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1381caa4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1381caa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../projects/tuushin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports